module.exports = __webpack_public_path__ + "static/azul-portugal-59a27258f0cf491b7c65cbbde9350577.png";